import { env } from '../env';

export const getRunsInFip = () => {
	const runsInFip = env.CLIENT_RUNS_IN === 'FIP';
	return runsInFip;
};
